import { render, staticRenderFns } from "./objectOfExpenditures.vue?vue&type=template&id=b84e1b8a&"
import script from "./objectOfExpenditures.vue?vue&type=script&lang=js&"
export * from "./objectOfExpenditures.vue?vue&type=script&lang=js&"
import style0 from "./objectOfExpenditures.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports